import React from 'react'
import { connect } from 'react-redux'
import { get } from 'lodash'
import Dimensions from 'react-dimensions'
import { Origin } from 'redux-tooltip'
import './index.css'

const Otext = Origin.wrapBy('text')
const CAT_A_TOOLTIP = (
  <div style={{ width: 300 }}>
    Provisions that the Member will implement by the time the Agreement enters
    into force (or in the case of a least-developed country Member within one
    year after entry into force)
  </div>
)
const CAT_B_TOOLTIP = (
  <div style={{ width: 300 }}>
    Provisions that the Member will implement after a transitional period
    following the entry into force of the Agreement
  </div>
)
const CAT_C_TOOLTIP = (
  <div style={{ width: 300 }}>
    Provisions that the Member will implement on a date after a transitional
    period following the entry into force of the Agreement and requiring the
    acquisition of assistance and support for capacity building.
  </div>
)

class TrendChartTFAArticle extends React.PureComponent {
  render() {
    //const { dataByCountry, countryCode, indicatorData, height=50, numYears=7, containerWidth } = this.props
    const {
      height = 50,
      containerWidth,
      showScores = true,
      dataByCountry,
      comparisonDataByCountry = null,
      valueMax,
    } = this.props

    // const margin = 4
    const pieceWidth = containerWidth / 4

    const getNormalizedValue = dataset => label => {
      const absValue = dataset[label]
      const maxValue = valueMax
      return `${((100 * absValue) / maxValue).toFixed(0)}%`
    }

    const getNormalizedData = getNormalizedValue(dataByCountry)
    const getNormalizedComparison = getNormalizedValue(comparisonDataByCountry)

    return (
      <svg height={height} className="TrendChartTFAArticle__svg">
        {/* scores if needed */}
        {showScores && (
          <g transform={`translate(0 ,0)`}>
            {dataByCountry &&
              get(dataByCountry, 'v') !== null &&
              comparisonDataByCountry === null && (
                <g>
                  <text
                    y={0}
                    x={pieceWidth / 2}
                    className="TrendChartTFAArticle__toplabel"
                  >
                    SCORE
                  </text>
                  <text
                    y={height / 2}
                    x={pieceWidth / 2}
                    className="TrendChartTFAArticle__score_country"
                  >
                    {getNormalizedData('v')}
                  </text>

                  <Otext
                    content={CAT_A_TOOLTIP}
                    y={0}
                    x={pieceWidth + pieceWidth / 2}
                    className="TrendChartTFAArticle__toplabel"
                  >
                    CATEGORY A
                  </Otext>
                  <text
                    y={height / 2}
                    x={pieceWidth + pieceWidth / 2}
                    className="TrendChartTFAArticle__score_country"
                  >
                    {getNormalizedData('A')}
                  </text>

                  <Otext
                    content={CAT_B_TOOLTIP}
                    y={0}
                    x={pieceWidth * 2 + pieceWidth / 2}
                    className="TrendChartTFAArticle__toplabel"
                  >
                    CATEGORY B
                  </Otext>
                  <text
                    y={height / 2}
                    x={pieceWidth * 2 + pieceWidth / 2}
                    className="TrendChartTFAArticle__score_country"
                  >
                    {getNormalizedData('B')}
                  </text>

                  <Otext
                    content={CAT_C_TOOLTIP}
                    y={0}
                    x={pieceWidth * 3 + pieceWidth / 2}
                    className="TrendChartTFAArticle__toplabel"
                  >
                    CATEGORY C
                  </Otext>
                  <text
                    y={height / 2}
                    x={pieceWidth * 3 + pieceWidth / 2}
                    className="TrendChartTFAArticle__score_country"
                  >
                    {getNormalizedData('C')}
                  </text>
                </g>
              )}
            {dataByCountry &&
              get(dataByCountry, 'v') !== null &&
              comparisonDataByCountry &&
              get(comparisonDataByCountry, 'v') !== null && (
                <g>
                  <text
                    y={0}
                    x={pieceWidth / 2}
                    className="TrendChartTFAArticle__toplabel"
                  >
                    SCORE
                  </text>
                  <text
                    y={height / 2}
                    x={pieceWidth / 2}
                    className="TrendChartTFAArticle__score_country--multi"
                  >
                    {getNormalizedData('v')}
                    &nbsp;
                  </text>
                  <text
                    y={height / 2}
                    x={pieceWidth / 2}
                    className="TrendChartTFAArticle__score_comparison"
                  >
                    &nbsp;
                    {getNormalizedComparison('v')}
                  </text>

                  <Otext
                    content={CAT_A_TOOLTIP}
                    y={0}
                    x={pieceWidth + pieceWidth / 2}
                    className="TrendChartTFAArticle__toplabel"
                  >
                    CATEGORY A
                  </Otext>
                  <text
                    y={height / 2}
                    x={pieceWidth + pieceWidth / 2}
                    className="TrendChartTFAArticle__score_country--multi"
                  >
                    {getNormalizedComparison('A')}
                    &nbsp;
                  </text>
                  <text
                    y={height / 2}
                    x={pieceWidth + pieceWidth / 2}
                    className="TrendChartTFAArticle__score_comparison"
                  >
                    &nbsp;
                    {getNormalizedData('A')}
                  </text>

                  <Otext
                    content={CAT_B_TOOLTIP}
                    y={0}
                    x={pieceWidth * 2 + pieceWidth / 2}
                    className="TrendChartTFAArticle__toplabel"
                  >
                    CATEGORY B
                  </Otext>
                  <text
                    y={height / 2}
                    x={pieceWidth * 2 + pieceWidth / 2}
                    className="TrendChartTFAArticle__score_country--multi"
                  >
                    {getNormalizedData('B')}
                    &nbsp;
                  </text>
                  <text
                    y={height / 2}
                    x={pieceWidth * 2 + pieceWidth / 2}
                    className="TrendChartTFAArticle__score_comparison"
                  >
                    &nbsp;
                    {getNormalizedComparison('B')}
                  </text>

                  <Otext
                    content={CAT_C_TOOLTIP}
                    y={0}
                    x={pieceWidth * 3 + pieceWidth / 2}
                    className="TrendChartTFAArticle__toplabel"
                  >
                    CATEGORY C
                  </Otext>
                  <text
                    y={height / 2}
                    x={pieceWidth * 3 + pieceWidth / 2}
                    className="TrendChartTFAArticle__score_country--multi"
                  >
                    {getNormalizedData('C')}
                    &nbsp;
                  </text>
                  <text
                    y={height / 2}
                    x={pieceWidth * 3 + pieceWidth / 2}
                    className="TrendChartTFAArticle__score_comparison"
                  >
                    &nbsp;
                    {getNormalizedComparison('C')}
                  </text>

                  {/* <text y={height/3+margin} x={0} className="TrendChartTFAArticle__score_country--multi">{dataByCountry.v.toFixed(0)}</text>
              <text y={height/3*2+margin} x={0} className="TrendChartTFAArticle__score_comparison">{comparisonDataByCountry.v.toFixed(0)}</text>

              <text y={height/2+margin} x={pieceWidth+10} className="TrendChartTFAArticle__grade">A</text>
              <text y={height/3+margin} x={pieceWidth*2} className="TrendChartTFAArticle__grade_country--multi">{dataByCountry.A.toFixed(0)}</text>
              <text y={height/3*2+margin} x={pieceWidth*2} className="TrendChartTFAArticle__grade_comparison">{comparisonDataByCountry.A.toFixed(0)}</text>

              <text y={height/2+margin} x={pieceWidth*3+10} className="TrendChartTFAArticle__grade">B</text>
              <text y={height/3+margin} x={pieceWidth*4} className="TrendChartTFAArticle__grade_country--multi">{dataByCountry.B.toFixed(0)}</text>
              <text y={height/3*2+margin} x={pieceWidth*4} className="TrendChartTFAArticle__grade_comparison">{comparisonDataByCountry.B.toFixed(0)}</text>

              <text y={height/2+margin} x={pieceWidth*5+10} className="TrendChartTFAArticle__grade">C</text>
              <text y={height/3+margin} x={pieceWidth*6} className="TrendChartTFAArticle__grade_country--multi">{dataByCountry.C.toFixed(0)}</text>
              <text y={height/3*2+margin} x={pieceWidth*6} className="TrendChartTFAArticle__grade_comparison">{comparisonDataByCountry.C.toFixed(0)}</text> */}
                </g>
              )}
          </g>
        )}
      </svg>
    )
  }
}

const mapStateToProps = (state, props) => ({
  countries: state.countries,
  tfaMeta: state.tfaMeta,
})

export default connect(mapStateToProps)(Dimensions()(TrendChartTFAArticle))



// WEBPACK FOOTER //
// ./src/components/TrendChartTFAArticle/index.js